// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1__cc332a6d17e8bd52e9ab","cls2":"AccountMenu-cls2___7214687b604ce02f44c AccountMenu-cls1__cc332a6d17e8bd52e9ab"};